<template>
  <div class="flex flex-col items-center mt-6 gap-4 h-full sm:h-[21rem]">
    <l-pin-input v-model="pin" :length="4" :has-error="wrongValue" :show-eye="false" />
    <calculator-keypad
      class="w-72"
      :mode="CalculatorKeypadMode.SIMPLE"
      focused
      @number="onNumberClicked"
      @action="onActionClicked"
    />
  </div>
</template>

<script setup lang="ts">
import { LPinInput } from '@last/core-ui/paprika'

import CalculatorKeypad from '@/components/Calculator/CalculatorKeypad.vue'
import type { CalculatorKeypadActionsType } from '@/components/Calculator/types'
import { CalculatorKeypadActions, CalculatorKeypadMode } from '@/components/Calculator/types'

withDefaults(
  defineProps<{
    wrongValue?: boolean
  }>(),
  {
    wrongValue: false
  }
)

const pin = defineModel<string>({ default: '' })
const emit = defineEmits<{
  complete: [string]
}>()

function onNumberClicked(number: number): void {
  if (pin.value.length < 4) {
    pin.value = pin.value + number
  }
  if (pin.value.length === 4) {
    emit('complete', pin.value)
  }
}

function onActionClicked(action: CalculatorKeypadActionsType): void {
  if (action === CalculatorKeypadActions.CLEAR) {
    pin.value = ''
    return
  }

  if (action === CalculatorKeypadActions.BACKSPACE) {
    pin.value = pin.value.slice(0, -1)
    return
  }
}
</script>
